import React from 'react';
import PropTypes from 'prop-types';

class ItemCouponCode extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div className="xCopyContainer xMain">
        <p className="xCopy xCouponCode">{this.props.code}</p>
      </div>
    )
  }
}

ItemCouponCode.propTypes = {
  code: PropTypes.string.isRequired
}

export default ItemCouponCode;